// extracted by mini-css-extract-plugin
export var container = "CarouselPartners-module--container--A8yh4";
export var singleLogoContainer = "CarouselPartners-module--singleLogoContainer--qOunL";
export var singleLogo = "CarouselPartners-module--singleLogo--etRrR";
export var arrowButton = "CarouselPartners-module--arrowButton--6k2Ro";
export var arrowPrev = "CarouselPartners-module--arrowPrev--GhYzp";
export var arrowNext = "CarouselPartners-module--arrowNext--hszmG";